import {PbrExport, type MaterialMapsExporterCore} from "@cm/material-maps-exporter"
import {MaterialOutputType} from "@generated"

export const defaultExportWorkflow: PbrExport.Types.Workflow = "metalnessRoughness"
export const defaultExportEngine: PbrExport.Types.Engine = "vray"
export const defaultExportNormalY: MaterialMapsExporterCore.Types.NormalY = "y+up"
export const defaultExportFormat: MaterialMapsExporterCore.Types.Format = "png"
export const defaultExportResolution: MaterialMapsExporterCore.Types.Resolution = "original"

export const getDefaultPbrExportRequests = () => {
    const exports: [MaterialMapsExporterCore.Types.Format, MaterialMapsExporterCore.Types.Resolution, MaterialOutputType][] = [
        ["jpeg", "dpi72", MaterialOutputType.PbrExportDefaultJpegLow],
        ["jpeg", "original", MaterialOutputType.PbrExportDefaultJpegOriginal],
        ["tiff", "dpi72", MaterialOutputType.PbrExportDefaultTiffLow],
        ["tiff", "original", MaterialOutputType.PbrExportDefaultTiffOriginal],
        ["exr", "original", MaterialOutputType.PbrExportDefaultExrOriginal],
    ]

    return exports.map(([format, resolution, materialOutputType]) => {
        const exportName = `default_${format}_${resolution}`
        const conversionRequest = PbrExport.Config.conversionRequest(defaultExportWorkflow, defaultExportEngine, defaultExportNormalY, format, resolution)
        const exportRequest = PbrExport.Config.exportRequest(
            PbrExport.Config.exportFolder([conversionRequest, PbrExport.Config.conversionInfoRequest(conversionRequest, "info", "text")], exportName),
            {source: "materialRevision"},
        )
        return {
            ...exportRequest,
            displayName: `${format.toUpperCase()} - ${PbrExport.Utils.resolutionToString(resolution)}`,
            materialOutputType,
        }
    })
}

type PbrExportMaterialOutputType = Extract<
    MaterialOutputType,
    | MaterialOutputType.PbrExportCustom
    | MaterialOutputType.PbrExportDefaultExrOriginal
    | MaterialOutputType.PbrExportDefaultJpegLow
    | MaterialOutputType.PbrExportDefaultJpegOriginal
    | MaterialOutputType.PbrExportDefaultTiffLow
    | MaterialOutputType.PbrExportDefaultTiffOriginal
>

export const isPbrExportMaterialOutputType = (materialOutputType: MaterialOutputType): materialOutputType is PbrExportMaterialOutputType => {
    return [
        MaterialOutputType.PbrExportCustom,
        MaterialOutputType.PbrExportDefaultExrOriginal,
        MaterialOutputType.PbrExportDefaultJpegLow,
        MaterialOutputType.PbrExportDefaultJpegOriginal,
        MaterialOutputType.PbrExportDefaultTiffLow,
        MaterialOutputType.PbrExportDefaultTiffOriginal,
    ].includes(materialOutputType)
}
